import type { ServiceType } from '../models/ServiceType.ts';

interface ServiceInfo {
  label: string; // 中文顯示
  color: string; // 對應顏色
}

export const serviceMap: Record<ServiceType, ServiceInfo> = {
  CHARGING: { label: '充電站', color: '#C3FAE8' },
  PARKING: { label: '停車場', color: '#D0EBFF' },
  FUELING: { label: '加油站', color: '#FFE3E3' },
  MAINTENANCE: { label: '保修廠', color: '#F3D9FA' },
  INSPECTION: { label: '驗車場', color: '#C5F6FA' },
};

/**
 * 取得 service 對應的中文名稱
 */
export const getServiceLabel = (service: ServiceType): string => {
  return serviceMap[service]?.label || service;
};

/**
 * 取得 service 對應的顏色
 */
export const getServiceColor = (service: ServiceType): string => {
  return serviceMap[service]?.color || 'gray';
};

/**
 * 如果有多個 service，可以回傳對應的 label 與顏色陣列
 */
export const getServiceInfoList = (services: ServiceType[]): ServiceInfo[] => {
  return services.map((s) => serviceMap[s] || { label: s, color: 'gray' });
};
